import { n as reverificationError, r as reverificationErrorResponse, t as isReverificationHint } from "./authorization-errors-CBHAr6Ld.mjs";

export { isReverificationHint, reverificationError, reverificationErrorResponse };